import React from 'react';
import { TickMarkOutlined } from '@duxton-web/icons';

import './index.css';

const ListInputDetectionMesssage = ({
  unmatchedValues,
}: {
  unmatchedValues: string[];
}) => {
  return (
    <>
      <div className="list-input-detection-message-header">
        List input detected, press ENTER to select
      </div>
      {unmatchedValues.length > 0 ? (
        <div className="list-input-detection-message-content">
          These {unmatchedValues.length} invalid values will be ignored:{' '}
          <strong>{unmatchedValues.join(', ')}</strong>
        </div>
      ) : (
        <div className="list-input-detection-message-content">
          All values are valid <TickMarkOutlined />
        </div>
      )}
    </>
  );
};

export default ListInputDetectionMesssage;
